// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-ColumnContainer----styles-module---root---bdOh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ColumnContainer/styles.module.css
// module id = 47
// module chunks = 35783957827783 114276838955818 132339944140454